module.exports = __webpack_public_path__ + "static/img/nav_bg_fixed.8f19dd96.png";